import { api } from '../redux/api/axiosManager';

const API_BASE_URL = '/api/admin/dashboard';

/**
 * Activity Service - Dashboard aktivite verilerini yönetir
 */
export const activityService = {
  /**
   * Aktivite listesini getir
   * @param {Object} options - Query parametreleri
   * @param {number} options.limit - Maksimum kayıt sayısı (default: 50)
   * @param {number} options.offset - Atlanacak kayıt sayısı (default: 0)
   * @param {string} options.eventType - Event tipi filtresi (opsiyonel)
   * @param {string} options.userId - Kullanıcı ID filtresi (opsiyonel)
   * @param {string} options.dateFrom - Başlangıç tarihi (YYYY-MM-DD, opsiyonel)
   * @param {string} options.dateTo - Bitiş tarihi (YYYY-MM-DD, opsiyonel)
   * @returns {Promise<Object>} API response
   */
  getActivities: async (options = {}) => {
    try {
      const params = new URLSearchParams({
        limit: options.limit || 50,
        offset: options.offset || 0,
        ...(options.eventType && { eventType: options.eventType }),
        ...(options.userId && { userId: options.userId }),
        ...(options.dateFrom && { dateFrom: options.dateFrom }),
        ...(options.dateTo && { dateTo: options.dateTo }),
      });

      const response = await api.get(`${API_BASE_URL}/activities?${params}`);
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data || [],
          pagination: response.data.pagination || {},
        };
      }

      return {
        success: false,
        data: [],
        error: 'Beklenmeyen response formatı',
      };
    } catch (error) {
      // 400 hatası için daha açıklayıcı mesaj
      if (error.response?.status === 400) {
        return {
          success: false,
          data: [],
          error: 'API endpoint bulunamadı veya geçersiz parametre. WebSocket verileri kullanılıyor.',
        };
      }
      
      return {
        success: false,
        data: [],
        error: error.response?.data?.message || error.message || 'Aktiviteler yüklenemedi',
      };
    }
  },

  /**
   * Aktivite istatistiklerini getir
   * @param {Object} options - Query parametreleri
   * @param {string} options.dateRange - Tarih aralığı ('today', 'week', 'month') (default: 'today')
   * @returns {Promise<Object>} API response
   */
  getStats: async (options = {}) => {
    try {
      const params = new URLSearchParams({
        dateRange: options.dateRange || 'today',
      });

      const response = await api.get(`${API_BASE_URL}/activities/stats?${params}`);
      
      if (response.data && response.data.success) {
        // Backend'den gelen data formatını kontrol et
        let statsData = response.data.data || [];
        
        // Eğer data bir array değilse, kontrol et
        if (!Array.isArray(statsData)) {
          // Eğer obje ise, array'e çevirmeyi dene
          if (typeof statsData === 'object' && statsData !== null) {
            statsData = Object.values(statsData);
          } else {
            statsData = [];
          }
        }
        
        // ✅ Backend'den gelen summary.totalUniqueUsers'ı da döndür
        return {
          success: true,
          data: statsData,
          summary: response.data.summary || {},
          totalUniqueUsers: response.data.summary?.totalUniqueUsers || null, // ✅ Backend'den gelen totalUniqueUsers
          dateRange: response.data.dateRange,
          timestamp: response.data.timestamp,
        };
      }

      return {
        success: false,
        data: [],
        error: 'Beklenmeyen response formatı',
      };
    } catch (error) {
      return {
        success: false,
        data: [],
        error: error.response?.data?.message || error.message || 'İstatistikler yüklenemedi',
      };
    }
  },
};

